import { useCombinedRef } from '../useCombinedRef.js';
import { useVisibilityToggle } from './useVisibilityToggle.js';
import { useListbox } from './useListbox.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var useCombobox = function useCombobox(_ref) {
  var items = _ref.items,
      showResultsOnFocus = _ref.showResultsOnFocus,
      onControlClick = _ref.onControlClick,
      onControlFocus = _ref.onControlFocus,
      onControlBlur = _ref.onControlBlur,
      onControlKeyDown = _ref.onControlKeyDown,
      onActiveItemChange = _ref.onActiveItemChange,
      _ref$disableHideShow = _ref.disableHideShow,
      disableHideShow = _ref$disableHideShow === void 0 ? false : _ref$disableHideShow,
      _ref$itemPropGenerato = _ref.itemPropGenerator,
      userItemPropGenerator = _ref$itemPropGenerato === void 0 ? function () {
    return [null, {}];
  } : _ref$itemPropGenerato;

  // init hook to manage hide/show behavior
  var _useVisibilityToggle = useVisibilityToggle({
    controlClickBehavior: showResultsOnFocus ? 'none' : 'show',
    // if showing on focus then click handler is redundant since click will trigger focus
    controlFocusBehavior: showResultsOnFocus ? 'show' : 'none',
    controlBlurBehavior: 'hide',
    onControlClick: onControlClick,
    onControlFocus: onControlFocus,
    onControlBlur: onControlBlur,
    disabled: disableHideShow
  }),
      controlHasFocus = _useVisibilityToggle.controlHasFocus,
      visibilityControlProps = _useVisibilityToggle.controlProps,
      visibilityPanelProps = _useVisibilityToggle.panelProps,
      isVisible = _useVisibilityToggle.isVisible,
      visibilityProps = _objectWithoutProperties(_useVisibilityToggle, ["controlHasFocus", "controlProps", "panelProps", "isVisible"]); // init hook to manage listbox behavior, including keyboard controls from a11y


  var _useListbox = useListbox({
    items: items,
    disableKeyManager: !isVisible,
    onActiveItemChange: onActiveItemChange,
    onControlKeyDown: onControlKeyDown,
    itemPropGenerator: userItemPropGenerator
  }),
      listboxPanelProps = _useListbox.listboxProps,
      listboxProps = _objectWithoutProperties(_useListbox, ["listboxProps"]); // filter out the panel ref from hide/show hook to combine with listbox ref


  var visibilityPanelRef = visibilityPanelProps.ref,
      filteredUseVisibilityPanelProps = _objectWithoutProperties(visibilityPanelProps, ["ref"]);

  listboxPanelProps.tabIndex;
      var onKeyDown = listboxPanelProps.onKeyDown,
      activedescendant = listboxPanelProps['aria-activedescendant'],
      listboxRef = listboxPanelProps.ref,
      filteredListboxPanelProps = _objectWithoutProperties(listboxPanelProps, ["tabIndex", "onKeyDown", "aria-activedescendant", "ref"]);

  return _objectSpread(_objectSpread({
    controlHasFocus: controlHasFocus,
    controlProps: _objectSpread(_objectSpread({}, visibilityControlProps), {}, {
      onKeyDown: onKeyDown,
      'aria-activedescendant': activedescendant,
      role: 'combobox'
    }),
    panelProps: _objectSpread(_objectSpread({
      ref: useCombinedRef(visibilityPanelRef, listboxRef)
    }, filteredUseVisibilityPanelProps), filteredListboxPanelProps),
    isVisible: isVisible
  }, visibilityProps), listboxProps);
};

export { useCombobox };
